import general from './general.json'
import menu from './menu.json'
import pages from './pages.json'

export default {
    general,
    menu,
    pages
}